module.exports = __webpack_public_path__ + "index_pc/img/a3.375ec77a.png";